import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { useIntl } from '../../util/reactIntl';
import { LayoutSingleColumn, Page } from '../../components';
import SectionFooter from '../PageBuilder/SectionBuilder/SectionFooter';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import TrustedServicesPage from './sections/TrustedServicesPage';
import BirdPage from './sections/BirdPage';
import CatPage from './sections/CatPage';
import RabbitPage from './sections/RabbitPage';
import DogPage from './sections/DogPage';

// import NotFoundPage from '../NotFoundPage/NotFoundPage';
import css from './PetSittingServicesPage.module.css';

const serviceComponents = {
  'trusted-services': TrustedServicesPage,
  'bird-sitting': BirdPage,
  'cat-sitting': CatPage,
  'rabbit-sitting': RabbitPage,
  'dog-sitting': DogPage,
};

const getTitle = (intl) => ({
  'trusted-services': intl.formatMessage({ id: 'PetSittingServicesPage.schemaTitle.trusted-services' }),
  'bird-sitting': intl.formatMessage({ id: 'PetSittingServicesPage.schemaTitle.bird-sitting' }),
  'cat-sitting': intl.formatMessage({ id: 'PetSittingServicesPage.schemaTitle.cat-sitting' }),
  'rabbit-sitting': intl.formatMessage({ id: 'PetSittingServicesPage.schemaTitle.rabbit-sitting' }),
  'dog-sitting': intl.formatMessage({ id: 'PetSittingServicesPage.schemaTitle.dog-sitting' }),
});

const getDescription = (intl) => ({
  'trusted-services': intl.formatMessage({ id: 'PetSittingServicesPage.schemaDescription.trusted-services' }),
  'bird-sitting': intl.formatMessage({ id: 'PetSittingServicesPage.schemaDescription.bird-sitting' }),
  'cat-sitting': intl.formatMessage({ id: 'PetSittingServicesPage.schemaDescription.cat-sitting' }),
  'rabbit-sitting': intl.formatMessage({ id: 'PetSittingServicesPage.schemaDescription.rabbit-sitting' }),
  'dog-sitting': intl.formatMessage({ id: 'PetSittingServicesPage.schemaDescription.dog-sitting' }),
});

const PetSittingServicesPageComponent = ({ params, scrollingDisabled, staticContext }) => {
  const { serviceType = 'trusted-services' } = params;
  const intl = useIntl();

  // if (!serviceType || !serviceComponents[serviceType]) {
  //   return <NotFoundPage staticContext={staticContext} />;
  // }

  const SelectedService = serviceComponents[serviceType];

  const title = getTitle(intl);
  const description = getDescription(intl);

  const schemaTitle = title[serviceType];
  const schemaDescription = description[serviceType];

  return (
    <Page
      scrollingDisabled={scrollingDisabled}
      title={schemaTitle}
      description={schemaDescription}
    >
      <LayoutSingleColumn
        topbar={<TopbarContainer />}
        footer={<SectionFooter />}
        mainColumnClassName={css.mainColumnClassName}
      >
        <SelectedService />
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
}

const PetSittingServicesPage = compose(connect(mapStateToProps))(PetSittingServicesPageComponent);

export default PetSittingServicesPage;
